import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ExportService from "../../api/export";


export const getAllowedExportFields = createAsyncThunk(
  "exportFields/get",
  async (args, thunkAPI) => {
    try {
      const response = await ExportService.getExportFields(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getExportPreview = createAsyncThunk(
  "exportPreview/get",
  async (args, thunkAPI) => {
    try {
      const response = await ExportService.getExportPreview(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createExport = createAsyncThunk(
  "export/post",
  async (args, thunkAPI) => {
    try {
      const response = await ExportService.createExport(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getExports = createAsyncThunk(
  "exports/get",
  async (args, thunkAPI) => {
    try {
      const response = await ExportService.getExports(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getExportDetails = createAsyncThunk(
  "export/get",
  async (args, thunkAPI) => {
    try {
      const response = await ExportService.getExportDetails(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getExportInfo = createAsyncThunk(
  "exportInfo/get",
  async (args, thunkAPI) => {
    try {
      const response = await ExportService.getExportInfo(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateExport = createAsyncThunk(
  "export/patch",
  async (args, thunkAPI) => {
    try {
      const response = await ExportService.updateExport(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const duplicateExport = createAsyncThunk(
  "export/duplicate",
  async (args, thunkAPI) => {
    try {
      const response = await ExportService.duplicateExport(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


const initialState = {
  exportFields: [],
  exportPreview: [],
  results: [],
  selectedExport: null,
  error: null,
  loading: false,
  loadingDetail: false,
  loadingUpdate: false,
  loadingCancel: false,
  shouldUpdate: false,
  exportInfo: [],
  loadingDuplicate: false,
};


const exportSlice = createSlice({
  name: "export",
  initialState,
  extraReducers: {
    [getAllowedExportFields.pending]: (state, action) => {
      //   state.loading = true;
    },
    [getAllowedExportFields.fulfilled]: (state, action) => {
      state.exportFields = action.payload;
      //   state.loading = false;
    },
    [getAllowedExportFields.rejected]: (state, action) => {
      //   state.error = "Ekki tókst að sækja";
      //   state.loading = false;
    },
    [getExportPreview.pending]: (state, action) => {
      //   state.loading = true;
    },
    [getExportPreview.fulfilled]: (state, action) => {
      state.exportPreview = action.payload;
      //   state.loading = false;
    },
    [getExportPreview.rejected]: (state, action) => {
      //   state.error = "Ekki tókst að sækja";
      //   state.loading = false;
    },
    [getExports.pending]: (state, action) => {
      state.loading = true;
    },
    [getExports.fulfilled]: (state, action) => {
      Object.assign(state, action.payload);
      state.loading = false;
      state.shouldUpdate = false
    },
    [getExports.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja";
      state.loading = false;
    },
    [getExportDetails.pending]: (state, action) => {
      state.loadingDetail = true;
    },
    [getExportDetails.fulfilled]: (state, action) => {
      state.selectedExport = action.payload;
      state.loadingDetail = true;
    },
    [getExportDetails.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja upplýsingar um útflutt gögn";
    },
    [updateExport.pending]: (state, action) => {
      // state.loadingDetail = true;
    },
    [updateExport.fulfilled]: (state, action) => {
      // state.selectedExport = action.payload;
      // state.loadingDetail = true;
    },
    [updateExport.rejected]: (state, action) => {
      // state.error = "Ekki tókst að sækja upplýsingar um útflutt gögn";
    },
    [getExportInfo.pending]: (state, action) => {
      // state.loadingDetail = true;
    },
    [getExportInfo.fulfilled]: (state, action) => {
      state.exportInfo = action.payload;
      // state.loadingDetail = true;
    },
    [getExportInfo.rejected]: (state, action) => {
      // state.error = "Ekki tókst að sækja upplýsingar um útflutt gögn";
    },
    [duplicateExport.pending]: (state, action) => {
      state.loadingDuplicate = true;
    },
    [duplicateExport.fulfilled]: (state, action) => {
      state.loadingDuplicate = true;
    },
    [duplicateExport.rejected]: (state, action) => {
      state.loadingDuplicate = false;
      state.error = "Ekki tókst að sækja upplýsingar um útflutt gögn";
    },
  },
});

const { reducer } = exportSlice;
export default reducer;